module.exports = __webpack_public_path__ + "static/aboutSec4-550bfb4c1102b1b51081024a8e5b9c69.png";